export default __webpack_public_path__ + "static/young-toddler14-827b30a13deb4c9a38c5562fafe8e46f.jpg";